export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  setAccessUsers(state, accessUsers) {
    state.accessUsers = accessUsers;
  },
  setAccessUser(state, accessUser) {
    state.accessUser = accessUser;
  },
  setLoadingExporting(state, loading) {
    state.loadingExporting = loading;
  },
  setUsers(state, users) {
    state.users = users;
  },
  setUser(state, user) {
    state.user = user;
  },
  setUsersPagination(state, users) {
    state.usersPagination = users;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/access-users/store/mutations.js